/**
 * Copyright (c) 2022, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 */

'use strict';

/**
 * oj-vb-switcher
 * @since  2210.0.0
 *
 * A wrapper of the oj-module composite component used to extend the capabilities
 * for Visual Builder purposes.
 *
 * <code>
 * &lt;oj-vb-switcher
 *   bridge='[[vbBridge]]'
 *   data='[[Array]]'
 *   current-item='{{currentItem}}'
 *   animation='[[moduleAnimation]]'&gt;
 * &lt;/oj-vb-switcher&gt;
 * </code>
 */
define('vb/components/oj-vb-switcher/loader',[
  'ojs/ojcomposite',
  'text!./component.json',
  './switcherViewModel',
  'ojs/ojmodule-element',
  'css!./styles.css',
], (Composite, metadataJson, viewModel) => {
  const metadata = JSON.parse(metadataJson);

  const view = `
<oj-bind-for-each data="[[moduleADP]]">
  <template>
    <oj-module config="[[getModuleConfigFromIndex($current.data.index)]]" animation="[[$props.animation]]"></oj-module>
  </template>
</oj-bind-for-each>
`;

  Composite.register('oj-vb-switcher', {
    view,
    viewModel,
    metadata,
  });
});

